/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷可能フラグ（水曜日）
 * @export
 * @interface EnableShipdayWed
 */
export interface EnableShipdayWed {
}

/**
 * Check if a given object implements the EnableShipdayWed interface.
 */
export function instanceOfEnableShipdayWed(value: object): value is EnableShipdayWed {
    return true;
}

export function EnableShipdayWedFromJSON(json: any): EnableShipdayWed {
    return EnableShipdayWedFromJSONTyped(json, false);
}

export function EnableShipdayWedFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableShipdayWed {
    return json;
}

export function EnableShipdayWedToJSON(json: any): EnableShipdayWed {
    return EnableShipdayWedToJSONTyped(json, false);
}

export function EnableShipdayWedToJSONTyped(value?: EnableShipdayWed | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

